angular.module('mean.projects').factory('taskService', ['$filter', '$q', '$rootScope', 'ProjectTasks',
    function($filter, $q, $rootScope, ProjectTasks) {
        //var tasks = [];

        var getByPhaseLot = function(phase, lot) {
            var deferred = $q.defer();

            ProjectTasks.query({'phase': phase, 'lot': lot},
                function(returned_tasks) {
                //tasks = returned_tasks;
                deferred.resolve(returned_tasks);
            });

            return deferred.promise;
        };

        var getByBuilderAndDateRange = function(owner, trade, project_id, phase, lot, task_code, start, end, limited) {
            var deferred = $q.defer();

            var startDate = new Date(start);
            var endDate = new Date(end);

            startDate.setHours(0);
            startDate.setMinutes(0);
            startDate.setSeconds(0);
            endDate.setHours(23);
            endDate.setMinutes(59);
            endDate.setSeconds(59);

            ProjectTasks.query({'type': 'builderDateRange', 'minReturn': limited,
                    'start': startDate, 'end': endDate, 
                    'owner': owner, 'trade': trade, 'project_id': project_id, 'phase': phase,
                    'lot': lot, 'task_code': task_code },
                function(returned_tasks) {

                deferred.resolve(returned_tasks);
            });

            return deferred.promise;
        };

        var getByTradeAndDateRange = function(owner, trade, project_id, phase, lot, task_code, main_username, start, end, limited) {
            var deferred = $q.defer();

            var startDate = new Date(start);
            var endDate = new Date(end);

            startDate.setHours(0);
            startDate.setMinutes(0);
            startDate.setSeconds(0);
            endDate.setHours(23);
            endDate.setMinutes(59);
            endDate.setSeconds(59);

            ProjectTasks.query({'type': 'tradeDateRange', 'minReturn': limited,
                    'start': startDate, 'end': endDate, 'main_username': main_username,
                    'owner': owner, 'trade': trade, 'project_id': project_id, 'phase': phase,
                    'lot': lot, 'task_code': task_code },
                function(returned_tasks) {

                deferred.resolve(returned_tasks);
            });

            return deferred.promise;
        };

        var getByManagerIdAndDateRange = function(id, owner, trade, project_id, phase, lot, task_code, start, end, limited) {
            var deferred = $q.defer();

            var startDate = new Date(start);
            var endDate = new Date(end);

            startDate.setHours(0);
            startDate.setMinutes(0);
            startDate.setSeconds(0);
            endDate.setHours(23);
            endDate.setMinutes(59);
            endDate.setSeconds(59);

            ProjectTasks.query({'type': 'managerDateRange', 'minReturn': limited,
                    'start': startDate, 'end': endDate, 'phase': phase,
                    'trade_manager_id': id, 'trade': trade, 'project_id': project_id,
                    'owner': owner, 'lot': lot, 'task_code': task_code },
                function(returned_tasks) {
                //tasks = returned_tasks;
                deferred.resolve(returned_tasks);
            });

            return deferred.promise;
        };

        var getByForemanAndDateRange = function(username, owner, trade, project_id, phase, lot, task_code, start, end, limited) {
            var deferred = $q.defer();

            var startDate = new Date(start);
            var endDate = new Date(end);

            startDate.setHours(0);
            startDate.setMinutes(0);
            startDate.setSeconds(0);
            endDate.setHours(23);
            endDate.setMinutes(59);
            endDate.setSeconds(59);

            ProjectTasks.query({'type': 'foremanDateRange', 'minReturn': limited,
                    'start': startDate, 'end': endDate, 'phase': phase,
                    'username': username, 'trade': trade, 'project_id': project_id,
                    'owner': owner, 'lot': lot, 'task_code': task_code },
                function(returned_tasks) {
                //tasks = returned_tasks;
                deferred.resolve(returned_tasks);
            });

            return deferred.promise;
        };

        var getByProjectIdLot = function(id, lot) {
            var deferred = $q.defer();

            ProjectTasks.query({'project_id': id, 'lot': lot.number},
                function(returned_tasks) {
                //tasks = returned_tasks;
                deferred.resolve(returned_tasks);
            });

            return deferred.promise;
        };

        var update = function(task) {
            var deferred = $q.defer();

            task.$update().then(function (response) {
                    //var update = $filter('filter')(tasks, {'_id': response._id}, true)[0];
                    //update = response;
                    deferred.resolve(response);
                }, function (error) {
                    console.error(error);
            });

            return deferred.promise;
        };

        var getByTrade = function(trade) {
            var deferred = $q.defer();

            ProjectTasks.query({'trade': trade},
                function(returned_tasks) {
                //tasks = returned_tasks;
                deferred.resolve(returned_tasks);
            });

            return deferred.promise;
        };

        var getByProjectTasksByIdLotPhase = function(project, item) {
            var deferred = $q.defer();
            if(!item.lot) item.lot = item.number;
            ProjectTasks.query({'trade': item.trade,
                'lot': item.lot,
                'phase': item.phase,
                'project_id': project._id }, function(project_bids) {
                    deferred.resolve(project_bids);
            });

            return deferred.promise;
        };

        var getProjectTasksForLot = function(projects) {
            var deferred = $q.defer();
            var list = [];
            var count = 0;
            var total = 0;
            _.each(projects, function(project) {
                //I'm sure there is a better way but this seems to work.
                //build the total amount of times i have to do a db query
                //and increment count every time it comes back.  defer 
                //the list when count matches total.
                total += project.get_tasks.length;
                _.each(project.get_tasks, function(item) {
                    getByProjectTasksByIdLotPhase(project, item).then(function(results) {
                        _.each(results, function(result) {
                            list.push(result);
                        });
                        count ++;
                    })
                    .then(function(data) {
                        if(count === total) {
                            deferred.resolve(list);
                        }
                    })
                    .catch(function(err) {
                        deferred.reject(err);
                    });
                });
            });

            return deferred.promise;
        }

        return {
            getByPhaseLot: getByPhaseLot,
            getByBuilderAndDateRange: getByBuilderAndDateRange,
            getByTradeAndDateRange: getByTradeAndDateRange,
            getByManagerIdAndDateRange: getByManagerIdAndDateRange,
            getByForemanAndDateRange: getByForemanAndDateRange,
            getByTrade: getByTrade,
            getByProjectIdLot: getByProjectIdLot,
            update: update,
            getProjectTasksForLot: getProjectTasksForLot
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/task-service.js